import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoginComponent } from '../../modals/login/login.component';
import { AuthServiceService } from '../../services/auth_services/auth-service.service';
import { ModalController, Platform } from '@ionic/angular';
import { StmgService } from '../../services/state_Management/stmg.service';
import { UserInfo } from '../../services/payload/userInfo_pobj';
import { AlertController } from '@ionic/angular';
import { AlertComponent } from '../../components/alert/alert.component';
import { BaseServiceService } from '../../services/base_service/base-service.service';
import { StorageServicesService } from 'src/app/services/storage_services/storage-services.service';
import { HeaderBarComponent } from '../header-bar/header-bar.component';
import { Router } from '@angular/router';


@Component({
  selector: 'app-slide-menu',
  templateUrl: './slide-menu.component.html',
  styleUrls: ['./slide-menu.component.scss'],
})
export class SlideMenuComponent implements OnInit {

  activePage: any;
  userInfo: UserInfo;
  is_android: boolean = false;
  latestVersion: string="";
  appUrl: string;
  @ViewChild(HeaderBarComponent) headerBar: HeaderBarComponent;
  showHomeElementsVar:boolean;

  constructor(
    public translate: TranslateService,
    public baseService:BaseServiceService,
    private authService: AuthServiceService,
    public alertController: AlertController,
    public modalController: ModalController,
    public platform: Platform,
    private stmgService: StmgService,
    private storageService: StorageServicesService, 
    private router: Router,
  ) {
    //translate.setDefaultLang('en');
  }

  is_logged = false;

  ngOnInit() {
    this.stmgService.is_logged_status.subscribe(message =>
      this.is_logged = message
    );
    
    this.stmgService.userInfoObervable.subscribe(userInfo =>
      this.userInfo = userInfo
    )

    if (this.platform.is('android')) {
      this.is_android = true;
    }

    this.getLatestVersion();


    const showHomeElements = this.storageService.getLocal("showHomeElements");

    if(showHomeElements == null || showHomeElements == "true"){
      this.showHomeElementsVar = true;
    }else{
      this.showHomeElementsVar = false;
    }

    this.stmgService.showHomeElements$.subscribe((value) => {
      this.showHomeElementsVar = value;
    });
  }

  //genarate apk url
  genApkUrl(){
    this.appUrl=this.baseService.envUrl()+"/StBET-"+this.latestVersion+".apk";
    //console.log(this.appUrl);
    //console.log(this.latestVersion);
    if(this.latestVersion!="" && this.latestVersion!=undefined){
      window.location.href=this.appUrl
    }else{
      let alert = new AlertComponent(this.alertController);
      alert.loginSuccessAlert("", "Download Failed", "Please Try Again");
    }
  }

  //get latest version
  getLatestVersion(){
    this.stmgService.version_status.subscribe(ver=>{
      //console.log(ver);
      this.latestVersion=ver;
    })
  }

  async launchLogin() {
    const modal = await this.modalController.create({
      component: LoginComponent,
      cssClass: 'customPopup'
    });
    return await modal.present();
  }

  dismiss() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  checkActive(page) {
    return page === this.activePage;
  }

  click_logout() {
    this.stmgService.updateLoginStatus(false);

    let alertTitle:string;
      let alertDesc:string;
      this.translate.get('ALERTS.LOGOUT.TITLE').subscribe((res: string) => {
        alertTitle=res;
      });
      this.translate.get('ALERTS.LOGOUT.DESC').subscribe((res: string) => {
        alertDesc=res;
      });
      let alert = new AlertComponent(this.alertController);
      alert.loginSuccessAlert("", alertTitle, alertDesc);

  }

  showHomeIcon(){
    this.storageService.localStore("showHomeElements",false);
    this.stmgService.setShowHomeElements(false);
    this.stmgService.headerBar$.subscribe(headerBar => {
      if (headerBar) {
        headerBar.updateShowHomeElements(false);
      }
    })
    // console.log("2222222222222",this.headerBar)
    // if (this.headerBar) {
    //   this.headerBar.updateShowHomeElements(false);
    // }
  }

  showHomeElements(){
    this.router.navigate(["/home/nextten"]);
    this.storageService.localStore("showHomeElements",true);
    this.stmgService.setShowHomeElements(true);

    // FOR VIRTUAL SECTION INSIDE CHANGE
    this.stmgService.setInVirtualSection(false);
  }

}
